import { HttpClient, HttpParams } from '@angular/common/http';
import { inject, Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { ApiResponse, PaginatedApiResponse } from '@card-software/nexus-utilities';
import { environment } from '../../../environments/environment';
import { Batch } from '../../models/production/batch/batch';
import {
  ProductionWorkOrder,
  ProductionWorkOrderInsert,
  ProductionWorkOrderSearchCommand,
  ProductionWorkOrderStatus,
} from '../../models/production/production-work-order';

@Injectable({
  providedIn: 'root',
})
export class ProductionWorkOrderProxyService {
  private readonly httpClient = inject(HttpClient);
  private readonly baseUrl = `${environment.proxyUrls.productionApi}/api/v1/production-work-order`;

  getById(id: string): Observable<ApiResponse<ProductionWorkOrder>> {
    return this.httpClient.get<ApiResponse<ProductionWorkOrder>>(`${this.baseUrl}/${id}`);
  }

  search(
    command: ProductionWorkOrderSearchCommand,
    pageNumber = 1,
    pageSize = 25,
    sortField?: string,
    sortOrder = -1,
  ): Observable<ApiResponse<PaginatedApiResponse<ProductionWorkOrder>>> {
    let params = new HttpParams().set('pageNumber', pageNumber.toString()).set('pageSize', pageSize.toString());
    if (sortField) {
      params = params.set('sortField', sortField).set('sortOrder', sortOrder.toString());
    }
    return this.httpClient.post<ApiResponse<PaginatedApiResponse<ProductionWorkOrder>>>(`${this.baseUrl}/search`, command, { params });
  }

  create(command: ProductionWorkOrderInsert): Observable<ApiResponse<ProductionWorkOrder>> {
    return this.httpClient.post<ApiResponse<ProductionWorkOrder>>(this.baseUrl, command);
  }

  update(id: string, command: ProductionWorkOrder): Observable<ApiResponse<void>> {
    return this.httpClient.put<ApiResponse<void>>(`${this.baseUrl}/${id}`, command);
  }

  changeStatus(id: string, newStatus: ProductionWorkOrderStatus): Observable<ApiResponse<ProductionWorkOrder>> {
    return this.httpClient.patch<ApiResponse<ProductionWorkOrder>>(`${this.baseUrl}/${id}/status`, newStatus);
  }

  getBatches(id: string): Observable<ApiResponse<Batch[]>> {
    return this.httpClient.get<ApiResponse<Batch[]>>(`${this.baseUrl}/${id}/batches`);
  }
}
